import { customAxios, IDUSUARIO, GENERIC_URL } from '../constants';

const CODIGO_MOTIVO_REPROGAMACION=47;

export default function() {
    const config = {
    params: {
      codGrupo: CODIGO_MOTIVO_REPROGAMACION,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  return customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config);
}


// WEBPACK FOOTER //
// ./src/utils/getTipoReprogramacion.js